import { env } from '@/config/env'
import { MARKETING_PRIVACY_PATH, MARKETING_TERMS_PATH } from './constants'

export function marketingTermsUrl(): string {
  return `${env.VITE_MARKETING_SITE_URL}${MARKETING_TERMS_PATH}`
}

export function marketingPrivacyUrl(): string {
  return `${env.VITE_MARKETING_SITE_URL}${MARKETING_PRIVACY_PATH}`
}
